import { render } from "./MainNavbar.vue?vue&type=template&id=452b6930&scoped=true&ts=true"
import script from "./MainNavbar.vue?vue&type=script&lang=ts"
export * from "./MainNavbar.vue?vue&type=script&lang=ts"

import "./MainNavbar.vue?vue&type=style&index=0&id=452b6930&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-452b6930"]])

export default __exports__